module.exports = __webpack_public_path__ + "img/message.4bc83c47.png";